import Authenticated from './authenticated/Authenticated.base';
import General from './general/General.base';
import Unauthenticated from './unauthenticated/Unauthenticated.base';

export default {
    Authenticated,
    General,
    Unauthenticated
}
